import { AccountPlaceholderPage } from "@/components/account/account-placeholder-page"

export default function MinhaContaDownloadsPage() {
  return (
    <AccountPlaceholderPage
      description='Use esta pagina para listar arquivos digitais liberados para a sua conta, com acesso rapido e historico de downloads.'
      title='Downloads'
    />
  )
}
